import React from 'react';
import { Info } from 'lucide-react';

/**
 * Round "i" info button that opens a WelcomeTourSheet. Used in the top-left
 * corner of pages that have a page-specific tour. Matches the premium styling
 * used elsewhere (purple ring, soft shadow).
 */
export default function PageInfoButton({ onClick, testId, ariaLabel = 'About this page' }) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={ariaLabel}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        border: '1px solid var(--card-border)',
        background: 'var(--surface)',
        color: 'var(--accent-purple)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: 'var(--premium-shadow-main)',
      }}
    >
      <Info size={18} strokeWidth={2} />
    </button>
  );
}
